/**
 * Determines the Oracle API URL based on the current environment.
 *
 * Local development talks to Oracle on the SSH box (`eassist-dev`) through a
 * port-forward: `yarn tunnel` maps 127.0.0.1:8081 → remote :8080. Override with
 * REACT_APP_ORACLE_API_URL in `.env.development.local` if needed.
 *
 * @type {string}
 * @throws {Error} Throws an error if an unrecognized React App environment is detected.
 */
const oracleApiUrl = (() => {
    switch (process.env.REACT_APP_ENV) {
        case 'development': {
            return (
                process.env.REACT_APP_ORACLE_API_URL || 'http://127.0.0.1:8081'
            ).replace(/\/$/, '');
        }
        case 'testing': {
            return 'https://oracle-api-testing.eassist.me'; // Testing API URL
        }
        case 'production': {
            return 'https://oracle-api.eassist.me'; // Production API URL
        }
        default: {
            throw new Error('Unrecognized React App Environment');
        }
    }
})();
export default oracleApiUrl;
